import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/userAuth/UserAuthState";
import { Spinner } from "react-bootstrap";

// Protects routes that require authentication — redirects to /login if not logged in
const ProtectedRoute = ({ children }) => {
  const { user, initialized } = useAuth();

  if (!initialized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
};

// Redirects already-authenticated users away from public routes (e.g. /login)
export const PublicRoute = ({ children }) => {
  const { user, initialized } = useAuth();

  if (!initialized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return user ? <Navigate to="/dashboard" replace /> : children;
};

export default ProtectedRoute;
